import Home from '@/router/views/Home.vue';

export default {
  path: '/management-practice',
  name: 'management-practice',
  component: Home,
  children: [
    {
      path: ':boardName/list',
      component: () => import('@components/management-board/BoardList.vue'),
    },
    {
      path: ':boardName/view/:id',
      component: () => import('@components/management-board/BoardView.vue'),
    },
    {
      path: ':boardName/write',
      component: () => import('@components/management-board/BoardWrite.vue'),
    },
    {
      path: ':boardName/write/:id',
      component: () => import('@components/management-board/BoardWrite.vue'),
    },
    {
      path: 'student-state/list',
      component: () => import('@components/counsel/StudentStateList.vue'),
    },
    {
      path: 'student-state/write',
      component: () => import('@components/counsel/StudentStateWrite.vue'),
    },
    {
      path: 'student-state/write/:id',
      component: () => import('@components/counsel/StudentStateWrite.vue'),
    },
    {
      path: 'student-statistics',
      component: () => import('@components/management-board/StudentStatistics.vue'),
    },
    {
      path: 'work-report/list',
      component: () => import('@components/management-board/work_report/WorkReportList.vue'),
    },
    {
      path: 'work-report/view/:id',
      component: () => import('@components/management-board/work_report/WorkReportView.vue'),
    },
    // {
    //   path: 'work-report/write',
    //   component: () => import('@components/management-board/work_report/WorkReportWrite.vue'),
    // },
    // {
    //   path: 'work-report/write/:id',
    //   component: () => import('@components/management-board/work_report/WorkReportWrite.vue'),
    // },
  ],
};
